import {
    READY_FAILURE, READY_SUCCESS
} from '../actions/ready';
const initialState = {
    readyResponse: null,
    readySuccess: null,
    readyFailure: null,
};

export default function readyReducer(state = initialState, action) {
    switch (action.type) {
        case READY_SUCCESS:
            return {
                ...state,
                readyResponse: action.data,
                readySuccess: true,
                readyFailure: null
            };
        case READY_FAILURE:
            return {
                ...state,
                readySuccess: null,
                readyFailure: true
            };
        default:
            return state;
    }
}